import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Chip,
  Card,
  CardContent,
  Stack,
  Box,

  Typography,

  ButtonGroup,
  DialogActions,
} from "@mui/material";
import getAllStore from "../../api/store/getAllStore";
import { useTheme } from "@mui/material/styles";
import getTable from "../../api/store/getTable";
import { CITIES } from "../../data/CITIES";
import SummaryReport from "../../component/management/SummaryReport";
import OrderReport from "../../component/management/OrdersReport";
import { AuthContext } from "../../context/AuthContext";
import zhTW from "date-fns/locale/zh-TW";
import { zhHK } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";

function ReportPage() {
  const [open, setOpen] = useState(false);
  const [selectedButton, setSelectedButton] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [filteredStores, setFilteredStores] = useState([]);
  const [reportDate, setReportDate] = useState({
    StartDate: new Date(new Date().setHours(0, 0, 0, 0)),
    EndDate: new Date(new Date().setHours(23, 59, 59, 999)),
  });

  const [stores, setStores] = useState([]);
  const [tables, setTables] = useState([]); // Initialize with your store data
  const [dateValid, setDateValid] = useState(false);
  const userContext = useContext(AuthContext);
  const theme = useTheme();
  const [cities, setCities] = useState([]);
  const [error, setError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [reportType, setReportType] = useState([
    { label: "總計報表", value: "summary", show: false },
    {label: "明細報表",value: "detail",show: false,},
  ]);
  const [selectedReport, setSelectedReport] = useState(null);
  useEffect(() => {
    if (reportDate.EndDate >= reportDate.StartDate) {
      setDateValid(true);
    }
  }, [reportDate]);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const data = await getAllStore();

        var userStore = [];
        if (userContext.user.Role === "Moderator") {
          data.stores.forEach((store) => {
            userContext.user.Permissions.forEach((p) => {
              if (store.Code === p.store) {
                userStore.push(store);
              }
            });
          });
          setStores(userStore);
        } else if (userContext.user.Role === "Admin") {
          setStores(data.stores);
        }
      } catch (err) {
        setError(err.message);
      }
    };

    if (stores) {
      fetchStores();
    }
  }, []);
  useEffect(() => {
    let tmpCity = {};
    let cityArray = [];
    for (var key in stores) {
      tmpCity[stores[key].City] = 1;
    }
    for (key in tmpCity) {
      cityArray.push(key);
    }

    cityArray.sort((a, b) => {
      return CITIES.indexOf(a) - CITIES.indexOf(b);
    });

    setCities(cityArray);
  }, [stores]);
  const onStoreSelected = (store) => {
    const fetchTables = async () => {
      try {
        const data = await getTable(store?.Code);
        if (data?.table) setTables(data.table);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchTables();
  };

  useEffect(() => {
    let tmpStores = [];
    stores.map((store, index) => {
      if (store.City === selectedButton) {
        tmpStores.push(store);
      }
    });

    setFilteredStores(tmpStores);
  }, [selectedButton]);

  const showReport = (index) => {
    disableAllReport()
    setReportType((prevReportType) => {
      // Create a copy of the array
      const newReportType = [...prevReportType];

      // Toggle the 'show' value of the first object
      newReportType[index] = {
        ...newReportType[index],
        show: !newReportType[index].show,
      };

      return newReportType;
    });
  };

  const disableAllReport = () => {
    setReportType((prevReportType) => {
      // Create a copy of the array
      const newReportType = [...prevReportType];

      // Set 'show' to false for all items except the one at 'index'
      newReportType.forEach((item, idx) => {
        newReportType[idx] = {
          ...item,
          show: false,
        };
      });

      return newReportType;
    });
  };
  const CustomActionBar = ({
    onAccept,
    onClear,
    onCancel,
    onSetToday,
    actions,
    className,
  }) => (
    <DialogActions
      className={className}
      sx={{ justifyContent: "space-between" }}
    >
      <Button variant="outlined" color="info" onClick={onCancel}>
        取消
      </Button>
      <Button variant="outlined" color="info" onClick={onAccept}>
        確認
      </Button>
    </DialogActions>
  );

  return (
    <>
      <Box>
        <Card sx={{ margin: "1px" }}>
          <CardContent>
            <Typography marginY={2} fontWeight={"bold"}>
              {"1.地區選擇："}
            </Typography>
            {cities.map((label, index) => (
              <Chip
                key={index}
                label={label}
                // Set the click handler to update the selected button
                onClick={() => {
                  disableAllReport();
                  setSelectedButton(label);
                  setTables([]);
                  setSelectedStore(null);
                }}
                sx={{
                  margin: "2px",
                  fontSize: "12pt",
                  border: 0.5,
                  backgroundColor:
                    selectedButton === label
                      ? theme.palette.info.main
                      : theme.palette.primary.main,
                  color:
                    selectedButton === label
                      ? theme.palette.text.selected
                      : "default",
                  "&:focus": {
                    backgroundColor: theme.palette.info.main,
                    color: theme.palette.text.selected,
                  },
                }}
              ></Chip>
            ))}
            <Typography marginY={2} fontWeight={"bold"}>
              {"2.店家選擇："}
            </Typography>
            <Stack direction={"row"} marginTop={1} padding={1}>
              {filteredStores?.length > 0 ? (
                <ButtonGroup variant="outlined">
                  {filteredStores.map((store, index) => (
                    <Button
                      key={"buttongroup" + index}
                      color="secondary"
                      onClick={() => {
                        disableAllReport();
                        setSelectedStore(index);
                      }}
                      sx={{
                        backgroundColor:
                          selectedStore === index
                            ? theme.palette.info.main
                            : null,
                        color: selectedStore === index ? "white" : "inherit",
                      }}
                    >
                      {store.Name}
                    </Button>
                  ))}
                </ButtonGroup>
              ) : (
                <Typography>{"請先選擇地區"}</Typography>
              )}
            </Stack>
            {selectedStore !== null ? (
              <>
                <Typography marginY={2} fontWeight={"bold"}>
                  {"3.報表選擇："}
                </Typography>
                <Stack direction={"row"} spacing={2} sx={{ marginTop: 5 }}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    localeText={
                      zhHK.components.MuiLocalizationProvider.defaultProps
                        .localeText
                    }
                    adapterLocale={zhTW}
                  >
                    <DateTimePicker
                      label="開始日期"
                      name="StartDate"
                      timeSteps={{minutes:1}}
                      slots={{ actionBar: CustomActionBar }}
                      slotProps={{
                        openPickerIcon: { fontSize: "large" },
                        openPickerButton: { color: "secondary" },
                        textField: {
                          color: "info",
                        },
                      }}
                      dayOfWeekFormatter={(_day, date) => {
                        format(date, "EEEEEE");
                      }}
                      ampm={false}
                      format="yyyy/MM/dd HH:mm"
                      defaultValue={new Date(reportDate.StartDate)}
                      value={new Date(reportDate.StartDate)}
                      onChange={(newValue) =>
                        setReportDate((prev) => ({
                          ...prev,
                          StartDate: new Date(newValue),
                        }))
                      }
                    />
                    <DateTimePicker
                      label="結束日期"
                      name="EndDate"
                      timeSteps={{minutes:1}}
                      ampm={false}
                      slots={{ actionBar: CustomActionBar }}
                      slotProps={{
                        openPickerIcon: { fontSize: "large" },
                        openPickerButton: { color: "secondary" },
                        textField: {
                          color: "info",
                        },
                      }}
                      dayOfWeekFormatter={(_day, date) => {
                        format(date, "EEEEEE");
                      }}
                      format="yyyy/MM/dd HH:mm"
                      defaultValue={new Date(reportDate.EndDate)}
                      value={new Date(reportDate.EndDate)}
                      onChange={(newValue) =>
                        setReportDate((prev) => ({
                          ...prev,
                          EndDate: new Date(newValue),
                        }))
                      }
                    />
                  </LocalizationProvider>
                </Stack>
                <ButtonGroup
                  value={selectedReport}
                  sx={{ marginTop: 2 }}
                  variant="outlined"
                >
                  {reportType.map((report, index) => (
                    <Button
                      key={"reprot" + index}
                      color="secondary"
                      onClick={() => {
                        setSelectedReport(index);
                        showReport(index);
                      }}
                      sx={{
                        backgroundColor:
                          selectedReport === index
                            ? theme.palette.info.main
                            : null,
                        color: selectedReport === index ? "white" : "inherit",
                      }}
                    >
                      {report.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </>
            ) : null}
          </CardContent>
        </Card>

        {reportType[0].show ? (
          <SummaryReport
            show={reportType[0].show}
            storeCode={filteredStores[selectedStore]?.Code}
            startDate={reportDate.StartDate}
            endDate={reportDate.EndDate}
          ></SummaryReport>
        ) : null}
        {reportType[1].show ? (
          <OrderReport
            show={reportType[1].show}
            storeCode={filteredStores[selectedStore]?.Code}
            startDate={reportDate.StartDate}
            endDate={reportDate.EndDate}
          ></OrderReport>
        ) : null}
      </Box>
    </>
  );
}

export default ReportPage;
